// extracted by mini-css-extract-plugin
module.exports = {"TopMenu":"TopMenu_TopMenu__2I_ug","selected":"TopMenu_selected__2fKPE"};